<template>
    <div class="about-view">
        <div class="banner-view" />
        <div class="safe-area">
            <div class="u-flex u-row-between u-m-t-45">
                <div>
                    <div class="title-view u-m-b-60">{{ '关于纳软' }}</div>
                    <p  v-html="content_first"></p>
    
                </div>
                <div class="pic_view" :style="{'background-image': 'url(' + pic_view_image + ')'}"></div>
            </div>
            <div class="title-view u-m-t-40 u-m-b-25">{{ '联系我们' }}</div>
			<div class="title-view2 u-m-b-35">期待您的合作与建议</div>
            <div class="about-box">
                <div class="" v-for="(item, index) in aboutList" :key="index">
                    <img :src="item.img" alt="" class="about-icon">
                    <div class="about-title">{{ item.title }}</div>
                    <div class="bold font-18">{{ item.sub }}</div>
                </div>
            </div>
            <div class="map-img" :style="{'background-image': 'url(' + map_img + ')'}"/>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AboutView',
    data() {
        return {
            content_first: '厦门纳软信息技术有限公司是一家为小、微企业提供数字化管理服务的高新技术公司。公司致力于在垂直细分行业提供更精准、更实用的信息化云服务。目前，公司已为中国两千多家的企业用户提供信息化服务，帮助企业提高效率、管控风险、降低成本、提质增效。',
            content_second: '公司依托SaaS模式，结合云计算、大数据、AI技术，基于工程企业所面临的管理问题研发出【纳软工程助手】管理软件，满足施工项目多场景的信息化管理需求，致力于为小、微建筑企业提供施工项目管理等移动数据智能解决方案，推动施工项目信息化管理转型升级。',
            aboutList: [
                {
                    title: '咨询热线',
                    sub: '400-000-0000',
                    img: require('@/assets/about/phone.png')
                },
                {
                    title: '邮箱',
                    sub: '400-000-0000',
                    img: require('@/assets/about/email.png')
                },
                {
                    title: '地址',
                    sub: '福建省厦门市湖里区泗水道597号1605',
                    img: require('@/assets/about/map.png')
                },
            ],
			data:[],
			pic_view_image:"",
			map_img:""
        }   
    },	
	mounted() {
		this.fetchWebsiteConfig();
	},
	methods: {
		async fetchWebsiteConfig() {
			const response = await fetch(this.$apiBaseUrl+"/api/website/website_conf");
			const data = await response.json();
			this.data=data.data
			this.content_first=data.data.details;
			this.aboutList[0]['sub']=data.data.phone;
			this.aboutList[1]['sub']=data.data.email;
			this.aboutList[2]['sub']=data.data.address;
			if(data.data.images){
				this.pic_view_image=data.data.images[0];
			}
			if(data.data.map_image){
				this.map_img=data.data.map_image;
			}
			
			
			console.log(data.data)
		}
	}       
}
</script>
<style lang="scss" scoped>
.about-view {
    .banner-view {
        height: 510px;
        background-image: url('../assets/about/banner.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title-view {
        color: #333;
        font-size: 30px;
        font-weight: bold;
        position: relative;
        &::after {
            height: 4px;
            width: 60px;
            content: '';
            position: absolute;
            bottom: -10px;
            left: 0;
            background-image: url('../assets/about/img.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
        }
    }
    .title-view {
        &~p {
            margin: 0;
            line-height: 38px;
            color: #333;
            text-indent: 32px;
        }
    }
	.title-view2{
		color: #333;
		font-size: 17px;
		font-weight: bold;
	}
    .pic_view {
        width: 540px;
        height: 410px;
        flex: none;
        margin-left: 60px;

        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
    .about-box {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 48px;
        margin-bottom: 30px;
        & > div {
            height: 240px;
            background: #FFFFFF;
            box-shadow: 0px 0px 10px 0px rgba(36,82,131,0.1);
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #333;
            .about-icon {
                width: 84px;
                height: 84px;
            }
            .about-title {
                color: #72777C;
                font-size: 14px;
                margin: 20px 0;
            }
        }
    }
    .map-img {
        width: 1200px;
        height: 506px;
        background: #F4E4B0;
        border-radius: 10px;
        margin-bottom: 45px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
    }
}
</style>